var map = {
	"./action_selected.svg": 2674,
	"./add_order.svg": 5491,
	"./bianji.svg": 8210,
	"./dagl_weixuanzhong.svg": 6886,
	"./del.svg": 8470,
	"./home.svg": 4149,
	"./statements.svg": 2527,
	"./tenant.svg": 6266,
	"./tianjia.svg": 6648,
	"./xiangqing.svg": 2744,
	"./xiugai.svg": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;